module.exports = __webpack_public_path__ + "static/media/with-text.bffda720.png";